import {
  CheckboxProps,
  ColProps,
  FormItemProps,
  InputNumberProps,
  InputProps,
  SelectProps,
  TreeSelectProps,
} from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import { TextAreaProps } from 'antd/es/input';
import { DatePickerProps } from 'antd/lib';

interface IFieldLink {
  to: string;
  name: string;
  external?: boolean;
}

interface IFieldProps {
  name: string | string[];
  type: TFieldProps.type;
  colProps?: ColProps;
  showTime?: boolean;
  isToggle?: boolean;
  allowClear?: boolean;
  inputStyles?: React.CSSProperties;
  itemClassName?: string;
  renderCustomField?: (props: { name: string | string[] }) => React.ReactNode;
  // img
  imgWidth?: number;
  entityType?: 'RETAILER' | 'OFFER' | 'PRODUCT';
  // link:
  link?: IFieldLink | IFieldLink[];
  // if you need manage field directly
  onDateChange?: DatePickerProps['onChange'];
  onTextChange?: React.ChangeEventHandler<HTMLInputElement>;
  onSelectChange?: SelectProps['onChange'];
  onCheckboxChange?: CheckboxProps['onChange']
  onDateRangeChange?: RangePickerProps['onChange'];
}

export type TFieldProps = Omit<FormItemProps
& InputProps
& InputNumberProps
& TreeSelectProps
& SelectProps
& Pick<RangePickerProps, 'allowEmpty'>
& Omit<TextAreaProps, 'prefix'>, 'name'>
& IFieldProps;

export namespace TFieldProps {

  export enum type {
    Link = 'link',
    Text = 'text',
    Image = 'image',
    Number = 'number',
    Select = 'select',
    Percent = 'percent',
    Textarea = 'textarea',
    Currency = 'currency',
    Checkbox = 'checkbox',
    TreeSelect = 'treeSelect',
    DatePicker = 'datePicker',
    ImageUpload = 'imageUpload',
    DateDiapasons = 'dateDiapasons',
    DateRangePicker = 'dateRangePicker',
    FormToggleField = 'toggleField',
    Custom = 'custom',
  }

}
